import superconciergerie from '../../services/superconciergerie';
import accountService from '../../services/account';
import Vue from 'vue';

export default {
  data() {
    return {
      loading: true,
      activeTab: 'summary',
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading: require('components/loading/loading.vue'),
    SummaryTab: require('./tabs/SummaryTab.vue'),
    ConfigurationTab: require('./tabs/ConfigurationTab.vue'),
    DashboardTab: require('./tabs/DashboardTab.vue'),
    ReservationsTab: require('./tabs/ReservationsTab.vue'),
    FacturationTab: require('./tabs/FacturationTab.vue'),
    SettingsTab: require('./tabs/SettingsTab.vue'),
    InvoiceView: require('./tabs/InvoiceTab.vue'),
    FilterSelectorTemplate: require('./components/FilterSelectorTemplate.vue'),
    DateFilterSelectorTemplate: require('./components/DateFilterSelectorTemplate.vue'),
  },

  methods: {
    async change_tab(tab) {
      const vm = this;
      vm.activeTab = tab;
      if(tab === 'invoice') {
        Vue.router.push({
          name: 'superconcierge.tab',
          params: {
            tab: vm.activeTab,
            ownerId: vm.$route.params.ownerId,
            month: vm.$route.params.month,
            year: vm.$route.params.year,
            type: vm.$route.params.type,
          },
        });
      }else{
        Vue.router.push({
          name: 'superconcierge.tab',
          params: {
            tab: vm.activeTab,
          },
        });
      }
    },
    deleteTeamMember(id) {
      let vm = this;
      swal({
          title: "Are you sure?",
          text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>You will not be able to recover this user</div>',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: 'Yes, delete it!',
          closeOnConfirm: false,
          html: true
        },
        function () {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();
          accountService.deleteTeamMembers(vm, id);
        });
    },
    async showInputField(obj, field, objName, fallback, vm) {
      const objId = obj.id;
      if (vm.updateField && vm.updateField === objId + "-" + field) {
        return;
      }
      vm.updateField = objId + "-" + field;

      let input = document.createElement("input");
      input.setAttribute("type", "number");
      input.setAttribute("step", "0.01");
      input.setAttribute("id", "input-" + objId + "-" + field);
      input.setAttribute("class", "form-control");
      input.setAttribute(
        "value",
        obj[field] === null ? 0 : obj[field]
      );
      if(objName === 'booking-') {
        input.setAttribute("style", "height: 21px; font-size: 11px; padding: 2px;");
      } else{
        input.setAttribute("style", "width: 75px;");
      }
      // Save on clicking outside field or on enter key press
      input.addEventListener("blur", async () => {
        fallback(obj, field, vm);
      });
      input.addEventListener("keyup", async (e) => {
        if (e.key === "Enter") {
          fallback(obj, field, vm);
        }
      });

      document.getElementById(objName + objId + "-" + field).innerHTML =
        "";
      document
        .getElementById(objName + objId + "-" + field)
        .appendChild(input);
      document.getElementById("input-" + objId + "-" + field).focus();
    },
  },

  async mounted() {
    if (this.$route.params.tab) {
      this.change_tab(this.$route.params.tab);
    }
    this.loading = false;
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/superconciergerie/superconciergerie.js